export const SIGNINUSER = "SIGNINUSER";
export const ASSOCIATESTORECODE = "ASSOCIATESTORECODE";
export const ADDFORTIVA = "ADDFORTIVA";